import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';

export function GelContentsBlock(props) {

  const {t} = useTranslation();

  const getLanes = () => {

    let lanes = [];

    for(var lane in props.lanes){
      lanes.push({
        lane: lane,
        contents: (props.lanes[lane].solutionAlias !== "")?
                    props.lanes[lane].solutionAlias:
                    t("Empty.string")
      })
    }

    return (
      <div>
        <h3 className={`${props.className}_header`}>{t('Choose a lane')}</h3>
        <div className={`${props.className}_wrapper`}>
          <h3 className={`${props.className}_title`}>{t('GelContains.string')}</h3>
          <ul className={`${props.className}_list`}>
            {lanes.map(lane => (
              <li className={
                (lane.lane == props.selectedLane)?
                  `${props.className}_listItem selected`:
                    (lane.contents === t("Empty.string"))?
                      `${props.className}_listItem empty`:
                      `${props.className}_listItem`
              }>
                <span>{t(lane.lane + ".string")}</span>
                : {lane.contents}
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }

  return (
    <div className={`${props.className}_block`}>
      <div className={props.className}>
        {getLanes()}
      </div>
    </div>
  );
}

GelContentsBlock.propTypes = {
  /**
   * ClassName to set on status warning component
   */
  className: PropTypes.string,
  /**
   * Boolean to set the Microcentrifuge Balanced Status Yes/No
   */
  lanes: PropTypes.array,
};

GelContentsBlock.defaultProps = {};
